import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-remote-hw-desk",
  "use": "icon-soc-remote-hw-desk-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-remote-hw-desk\">\r\n  <path fill=\"currentColor\" d=\"M160 288h704v448H160V288zm64 64v320h576V352H224z\" />\r\n  <path fill=\"currentColor\" d=\"M288 416h192v32H288zm0 96h448v32H288zm0 96h320v32H288z\" />\r\n  <circle cx=\"768\" cy=\"640\" r=\"80\" fill=\"currentColor\" fill-opacity=\".4\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-remote-hw-desk.svg
// module id = Yy/t
// module chunks = 546